export default __webpack_public_path__ + "static/media/coach-bundle_white@1x.c1fbab7d.webp";